import { render, staticRenderFns } from "./UcProductGeneral.yaml?vue&type=template&id=937da6f2&component"
import script from "./UcProductGeneral.yaml?vue&type=script&lang=ts&component"
export * from "./UcProductGeneral.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports